<template>
  <div id="app">
    <NavBar :navgatorIndex="navgatorIndex" @clickMethod="callBack"/>
    <Swiper style="margin-top:66px;" v-if="this.listBox.includes(this.navgatorIndex)" @clickMethod="callBack"/>
    <router-view/>
    <Footer  @clickMethod="callBack"/>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import LoginBox from './components/LoginBox.vue'
import Footer from './components/Footer.vue'
import Swiper from './components/Swiper.vue'
export default {
  name: 'App',
  components: {
    NavBar,
    LoginBox,
    Footer,
    Swiper
  },
  data () {
    return {
      listBoxState: true,
      listBox: ['header', 'driver', 'huozhu', 'companyProfile', 'productsServices', 'contactUs'],
      navgatorIndex: 'header'
    }
  },
  created () {
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  mounted () {
    let timeId
    window.addEventListener('scroll', () => {
      // 页面滚动停止100毫秒后才会执行下面的函数。
      clearTimeout(timeId)
        this.scrollToTop()
    }, true)
    this.$router.push({path: '/Index', query: {mao: 'header'}})
    this.navgatorIndex = 'header'
  },
  beforeDestroy () { // 实例销毁之前对点击事件进行解绑
      window.removeEventListener('scroll')
  },
  methods: {
    callBack (option) {
      this.navgatorIndex = option
      switch (option) {
        case 'cooperation':
          this.$router.push('/cooperation')
          break
        case 'advertisement':
          this.$router.push('/advertisement')
          break
        default:
          this.$router.push({path: '/Index', query: {mao: option}})
          break
      }
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop () {
      if (!this.listBox.includes(this.navgatorIndex)) {
        return
      }
      // 获取视窗高度
      // var domHight = document.body.offsetHeight
      // dom滚动位置
      var scrollTop = document.documentElement.scrollTop
      if (this.listBoxState) { // 作用是点击导航栏时，延迟这里执行。
        this.listBox.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(v).offsetTop
          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(v).scrollHeight
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= (offsetTop + scrollHeight)) {
            // 导航栏背景色选中
            this.navgatorIndex = v
            console.log('this.navgatorIndex:', this.navgatorIndex)
          }
        })
      }
    }
  }
}
</script>

<style>
#app {
  position: relative;
}
.h2top{
  font-size: 1.5vw;
  color:#3699FF;
  text-align: center;
}
.h2bottom{
  color:#3699FF;
  text-align: center;
  font-size: 3vw;
  margin-top:10px;
  padding-bottom:10px;
}
.bg{
  height: 690px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-menu.el-menu--horizontal{
  border:none !important;
}
/* .bgbox{
  width:600px;
  height: 500px;
  border-radius: 20px;
  background: #fff;
  opacity: 0.8;
} */
.lineClass {
	height: 2px;
	background-color: #3699FF;
	width: 13vw;
	margin: 0px 43.5% 5vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue